module.exports = __webpack_public_path__ + "static/media/1005357.c115dc86.jpg";